import { Link } from "react-router-dom";

export default function CheckoutSuccess() {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold text-green-600">Payment Successful!</h1>
      <p>Thank you for subscribing. You now have full access.</p>
      <Link to="/dashboard" className="mt-4 bg-blue-500 text-white p-2 rounded">
        Go to Dashboard
      </Link>
    </div>
  );
}
